import React from "react";
import './styles.css'

const CommonScreenContentCenter = ({ children }) => {
    return (
        <div className="commonScreenContentCenter">{children}</div>
    )
}

export default CommonScreenContentCenter